import { OfferList } from 'shared/components/OfferList';
import { useSelector } from 'react-redux';
import { selectCalculatorValues, selectCalculatorErrors } from 'shared/selectors/landing';
import { MortgageOfferValidation } from 'shared/components/MortgageOfferValidation';
import { selectBanksLogos } from '../../selectors/dictionaries';
import React, { useEffect } from 'react';
import { TMapOffersResult } from '../../types/common/offer';
import { MortgageOfferEmpty } from '../../components/MortgageOfferEmpty';
import { Loader } from '../../components/Loader';
import { getObjectForAnalyticsAboutShowingOffers } from '../../utils/tracking/utils/getObjectForAnalyticsAboutShowingOffers';
import { useTracking } from '../../utils/tracking/useTracking';

export interface IListingContainerProps {
  mappedOffersList: TMapOffersResult;
  offersIsFetching: boolean;
}

export const ListingContainer: React.FC<IListingContainerProps> = ({ mappedOffersList, offersIsFetching }) => {
  const { trackShowOffers } = useTracking();
  const calculatorValues = useSelector(selectCalculatorValues);
  const banksLogos = useSelector(selectBanksLogos);
  const calculatorErrors = useSelector(selectCalculatorErrors);

  useEffect(() => {
    if (!offersIsFetching) {
      trackShowOffers(getObjectForAnalyticsAboutShowingOffers(mappedOffersList));
    }
  }, [offersIsFetching]);

  if (!calculatorValues || calculatorErrors.length > 0) {
    return <MortgageOfferValidation errors={calculatorErrors} bankList={banksLogos} />;
  }

  if (offersIsFetching) {
    return <Loader text={'Загружаем лучшие предложения...'} />;
  }

  if (mappedOffersList.length === 0) {
    return <MortgageOfferEmpty />;
  }

  return <OfferList offersList={mappedOffersList} />;
};
